<template>
  <div class="text-xs md:text-header-window">
    <div class="flex text-xxs md:text-xs w-full items-center justify-center md:justify-start flex-wrap gap-4 md:min-w-80 md:ml-1">
      <div class="flex flex-col items-center flex-wrap">
        <img src="/img/icons/projects/tools/photoshop.png" :alt="$t('common.icon') + ' vuejs'" class="w-9 h-9 p-px" />
        <p class="font-bold mt-px">Photoshop</p>
      </div>
      <div class="flex flex-col items-center flex-wrap">
        <img src="/img/icons/projects/tools/illustrator.png" :alt="$t('common.icon') + ' laravel'" class="w-9 h-9" />
        <p class="font-bold mt-px">Illustrator</p>
      </div>
    </div>
    <h3 class="mt-5 mb-2">{{ $t('common.context') }}</h3>
    <p>{{ $t('project.pangaia.contextFirstParagraph') }}</p>
    <p>{{ $t('project.pangaia.contextSecondParagraph') }}</p>
    <p>{{ $t('project.pangaia.contextThirdParagraph') }}</p>
    <h3 class="mt-5 mb-2">{{ $t('common.objectives') }}</h3>
    <p>{{ $t('project.pangaia.goalfirstParagraph') }}</p>
    <ul class="list-disc ml-3">
      <li>{{ $t('project.pangaia.goalFirst') }}</li>
      <li>{{ $t('project.pangaia.goalSecond') }}</li>
      <li>{{ $t('project.pangaia.goalThird') }}</li>
      <li>{{ $t('project.pangaia.goalFourth') }}</li>
    </ul>
    <h3 class="mt-5 mb-2">{{ $t('common.tasksDone') }}</h3>
    <ul class="list-disc ml-3">
      <li>{{ $t('project.pangaia.logoDoneFirst') }}</li>
      <li>{{ $t('project.pangaia.logoDoneSecond') }}</li>
      <li>{{ $t('project.pangaia.logoDoneThird') }}</li>
    </ul>
    <div class="w-full justify-center mt-5 mb-2 flex flex-row items-center gap-0.5 cursor-pointer transition-all hover:underline hover:text-heroic-blue">
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="18px"
        height="18px"
        viewBox="0 0 364.000000 364.000000"
        preserveAspectRatio="xMidYMid meet"
        class="fill-current"
      >
      </svg>
    </div>
    <div class="w-full flex items-center flex-col"> 
    </div>
    <div class="mb-2">
      <h3 class="mt-5">{{ $t('common.CDM') }}</h3>
      <p class="italic text-gray-500 text-xxs md:text-xs mb-px">
        {{ $t('project.pangaia.CDMText') }}
      </p>
      <img src="/img/projects/pangaia/background.png" :alt="$t('common.CDM') + ' - Pangaia'" />
    </div>
  </div>
  <a
    rel="noopener"
    href="https://www.dropbox.com/scl/fi/x75rpsmslauhj4a05tiss/Moodboard-v2.png?rlkey=c9uweplw6adkhbmjrezqssdn0&st=efhqm8c8&dl=0"
    target="_blank"
    class="absolute flex items-center justify-center bottom-2 right-1 md:right-6 h-6 text-xs border border-twilight-blue bg-button-submit rounded-sm leading-loose px-3 hover:shadow-button-submit-hover cursor-pointer active:bg-button-clicked"
  >
    {{ $t('buttons.linkWebSite') }}
  </a>
</template>


